import React, { useCallback, useState } from 'react';
import { Box } from '@mui/material';
import { omit } from 'lodash-es';
import { dropdownClasses } from './style';
import { Divider } from '../../Divider';
import { menuItemPositionIdName, menuListPositionIdName } from './constant';
import { getNextMenuItemElement, getPreviousMenuItemElement, getMenuListElement, getSiblingFirstMenuItemElement, getSiblingLastMenuItemElement, } from './dom';
import OverflowWrapper from '../../Shared/OverflowWrapper';
import { Tooltip } from '../../Tooltip';
export const NestedMenuGroup = (props) => {
    const { type, menuId, itemData, keyPath, indexPath, positionPath, renderNestedMenu, popperProps, menuItemProps, overlayClassName, parentDisabled, closeTopParentMenu, closeParentMenu, disablePortal, onRequestSubItems, } = props;
    const { label, children, tooltipProps = {} } = itemData;
    const [labelTabIndex, setLabelTabIndex] = useState(-1);
    const hasChildren = Array.isArray(children) && children.length > 0;
    const subItems = children;
    const labelUid = `${menuId}-label-${[...positionPath].join('-')}`;
    const handleItemKeyDown = useCallback((e) => {
        const activeElement = e.target;
        if (['ArrowDown', 'ArrowUp'].includes(e.key)) {
            e.stopPropagation();
            e.preventDefault();
            if (e.key === 'ArrowDown') {
                const newActiveDOM = getNextMenuItemElement(activeElement);
                newActiveDOM?.focus();
            }
            else {
                // Arrow up
                const newActiveDOM = getPreviousMenuItemElement(activeElement);
                newActiveDOM?.focus();
            }
        }
        else if (['ArrowLeft', 'Escape'].includes(e.key)) {
            closeParentMenu?.();
            const listElem = getMenuListElement(activeElement);
            if (menuId === listElem?.getAttribute(menuListPositionIdName)) {
                closeTopParentMenu();
            }
            else {
                e.stopPropagation();
                e.preventDefault();
            }
        }
        else if (['Home', 'End', 'PageDown', 'PageUp'].includes(e.key)) {
            e.stopPropagation();
            e.preventDefault();
            let activeDOM = null;
            if (['Home', 'PageUp'].includes(e.key)) {
                activeDOM = getSiblingFirstMenuItemElement(activeElement);
            }
            else {
                activeDOM = getSiblingLastMenuItemElement(activeElement);
            }
            activeDOM?.focus();
        }
    }, [closeParentMenu, menuId, closeTopParentMenu]);
    const [showTooltip, setShowTooltip] = useState(false);
    return (React.createElement(React.Fragment, null,
        itemData.showTopDivider && (React.createElement(Divider, { className: dropdownClasses.menuGroupDivider })),
        React.createElement(Tooltip, { title: showTooltip ? label : undefined, autoFocus: false, ...omit(tooltipProps, 'children') },
            React.createElement(Box, { component: "li", className: dropdownClasses.menuGroupTitle, role: "menuitem", tabIndex: labelTabIndex, "aria-disabled": "true", [menuItemPositionIdName]: labelUid, onKeyDown: handleItemKeyDown, onFocus: () => {
                    setLabelTabIndex(0);
                }, onBlur: () => {
                    setLabelTabIndex(-1);
                } },
                React.createElement(OverflowWrapper, { onMounted: ({ isOverflow }) => {
                        setShowTooltip(isOverflow);
                    } }, label))),
        hasChildren &&
            subItems.map((child, i) => renderNestedMenu({
                itemData: child,
                parentKeyPath: keyPath,
                parentIndexPath: indexPath,
                parentPositionPath: positionPath,
                index: i,
                siblingCount: subItems.length,
                popperProps,
                menuItemProps,
                overlayClassName,
                parentDisabled: parentDisabled ?? itemData.disabled,
                disablePortal,
                closeTopParentMenu,
                closeParentMenu,
                onRequestSubItems,
                type,
            })),
        itemData.showBottomDivider && (React.createElement(Divider, { className: dropdownClasses.menuGroupDivider }))));
};
